export default __webpack_public_path__ + "static/media/social-02.23383430.webp";